/* eslint-disable react/no-array-index-key */
import React from 'react';

const JanusVideoRoom = ({ children, janus }) => {
  return (
    <div
      style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
    >
      {children &&
        children.length &&
        children.map((child, i) =>
          React.cloneElement(child, { janus, key: i }),
        )}
      {children && !children.length && React.cloneElement(children, { janus })}
    </div>
  );
};

export default JanusVideoRoom;
